<template>
  <div class="item-base">
      <router-view>
      </router-view>
  </div>
</template>

<script>
  export default {
    name: "NewsEnter"
  }
</script>

<style lang="less" scoped>
.item-base{
  min-height: 90vh;
}
</style>